export default __webpack_public_path__ + "static/media/storageUnit1-beforeB-1024w.25a8edc2.webp";